import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpCenterSecondlevelComponent } from './help-center-secondlevel/help-center-secondlevel.component';
import { HelpCenterThirdlevelComponent } from './help-center-thirdlevel/help-center-thirdlevel.component';
import { HelpCenterComponent } from './help-center/help-center.component';
import { HelpCentersComponent } from './help-centers.component';
import {HelpCenterPreviewComponent} from './help-center-preview/help-center-preview.component';


const routes: Routes = [
 {path :"",component:HelpCentersComponent ,children:[
   { path: "HelpCenter", component: HelpCenterComponent },
   { path: "SecondLevel/:parentID", component: HelpCenterSecondlevelComponent },
   { path: "ThirdLevel/:parentID", component: HelpCenterThirdlevelComponent },
   {path:"Preview",component:HelpCenterPreviewComponent},
   {path:"", redirectTo: 'HelpCenter', pathMatch: 'full'}
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class HelpCenterRoutingModule { }
